// Sección de industrias en Admin

import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const IndustriasAdmin = () => {
    const [industrias, setIndustrias] = useState([]);
    const [newIndustria, setNewIndustria] = useState("");

    useEffect(() => {
        fetchIndustrias();
    }, []);

    const fetchIndustrias = async () => {
        try {
            const res = await fetch(`${BASE}/buscar_industrias.php`);
            const data = await res.json();
            setIndustrias(data);
        } catch {
            toast.error("Error al cargar industrias");
        }
    };

    const handleAdd = async () => {
        const nombre = newIndustria.trim();
        if (!nombre) return;
        try {
            const res = await fetch(`${BASE}/guardar_industria.php`, {
                method: "POST",
                body: new URLSearchParams({ nombre }),
            });
            const data = await res.json();
            if (data.ok) {
                toast.success("Industria agregada");
                setNewIndustria("");
                fetchIndustrias();
            } else {
                toast.error(data.error || "Error al agregar");
            }
        } catch {
            toast.error("Error de conexión");
        }
    };

    const handleEdit = async (ind) => {
        const newName = prompt("Nuevo nombre para la industria:", ind.nombre);
        if (!newName || newName.trim() === ind.nombre) return;
        try {
            const res = await fetch(`${BASE}/editar_industria.php`, {
                method: "POST",
                body: new URLSearchParams({ id: ind.id, oldName: ind.nombre, newName: newName.trim() }),
            });
            const data = await res.json();
            if (data.ok) {
                toast.success("Industria actualizada (y cascadeada en clientes)");
                fetchIndustrias();
            } else {
                toast.error(data.error || "Error al editar");
            }
        } catch {
            toast.error("Error de conexión");
        }
    };

    const handleDelete = async (ind) => {
        if (!window.confirm(`¿Eliminar la industria "${ind.nombre}"?`)) return;
        try {
            const res = await fetch(`${BASE}/eliminar_industria.php`, {
                method: "POST",
                body: new URLSearchParams({ id: ind.id }),
            });
            const data = await res.json();
            if (data.ok) {
                toast.success("Industria eliminada");
                fetchIndustrias();
            } else {
                toast.error(data.error || "Error al eliminar");
            }
        } catch {
            toast.error("Error de conexión");
        }
    };

    return (
        <section>
            <div className="container">
                <div className="container-addbar" style={{ marginTop: "40px" }}>
                    <input
                        type="text"
                        value={newIndustria}
                        onChange={(e) => setNewIndustria(e.target.value)}
                        placeholder="Nueva Industria"
                        onKeyDown={(e) => e.key === "Enter" && handleAdd()}
                    />
                    <button className="searchbar_form_submit" onClick={handleAdd}>
                        Agregar
                    </button>
                </div>

                <div className="categories-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Industria</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {industrias.map((ind) => (
                            <tr key={ind.id}>
                                <td>{ind.id}</td>
                                <td>{ind.nombre}</td>
                                <td>
                                    <div style={{ display: "flex", gap: "1px" }}>
                                        <FaRegEdit
                                            className="action-icon"
                                            onClick={() => handleEdit(ind)}
                                            style={{
                                                display: "flex", justifyContent: "center", alignItems: "center",
                                                width: "32px", height: "32px", backgroundColor: "#4893e9",
                                                borderRadius: "5px", cursor: "pointer", marginRight: "7px",
                                            }}
                                        />
                                        <MdDelete
                                            className="action-icon"
                                            onClick={() => handleDelete(ind)}
                                            style={{
                                                display: "flex", justifyContent: "center", alignItems: "center",
                                                width: "32px", height: "32px", backgroundColor: "#D9534F",
                                                borderRadius: "5px", cursor: "pointer",
                                            }}
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </div>
            </div>
        </section>
    );
};

export default IndustriasAdmin;
